import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const RegionPage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Region Name' },
    { key: 'counties', label: 'Counties' },
    { key: 'supervisor', label: 'Regional Supervisor' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'code', label: 'Region Code', type: 'text', required: true },
    { key: 'name', label: 'Region Name', type: 'text', required: true },
    { key: 'counties', label: 'Counties Covered', type: 'textarea', required: true, fullWidth: true },
    { key: 'supervisor', label: 'Regional Supervisor', type: 'text', required: false },
    { key: 'phone', label: 'Phone', type: 'text', required: false },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', code: 'HOU-C', name: 'Houston Central', counties: 'Harris (Inner Loop)', supervisor: 'Maria Rodriguez', active: 'Yes' },
    { id: '2', code: 'HOU-N', name: 'Houston North', counties: 'Harris (North), Montgomery', supervisor: 'John Smith', active: 'Yes' },
    { id: '3', code: 'HOU-S', name: 'Houston South', counties: 'Harris (South), Brazoria', supervisor: 'Emily Davis', active: 'Yes' },
    { id: '4', code: 'HOU-W', name: 'Houston West', counties: 'Harris (West), Fort Bend, Waller', supervisor: 'Michael Brown', active: 'Yes' },
    { id: '5', code: 'HOU-E', name: 'Houston East', counties: 'Harris (East), Chambers, Liberty', supervisor: 'Jennifer Wilson', active: 'Yes' },
    { id: '6', code: 'WOOD', name: 'The Woodlands', counties: 'Montgomery, Walker', supervisor: 'David Lee', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Region"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Region"
      formFields={formFields}
      apiEndpoint="/setup/region"
    />
  );
};

export default RegionPage;
